import React from 'react';

export default function GoogleSlidesIcon({ width = 60, height = 60 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width={width} height={height} fill="url(#pattern0_15363_4211)" />
      <defs>
        <pattern
          id="pattern0_15363_4211"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_15363_4211" transform="scale(0.01)" />
        </pattern>
        <image
          id="image0_15363_4211"
          width="100"
          height="100"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC8klEQVR4nO3dzWsTQRjH8QnCPtF4MBX9P7z5evIvUMhFkOJ/IogHKUa8C9ZWPBV8iRZKle6k8d0akGI9qoem6FzSkx70J6tYPWk1s5lnZn9feM6zmQ9LCJlljWGMMcYYYxGEvH4MVi4jl7uw2aLa6R+fR39yj0k1PDITsHIPVhDFvD4NvG9/xKtTTZNaWDANWOkH32T7jyCukyYKcpkKvsH2P0GKeXfRYbU1YVII80aQy2bUIC6hOwW2fjj45loPIKmgIM9OJgPiEkBBnrWSAnGRf6ckCeIiRkkWxEWKkjSIixAleRAXGUolQFxEKJUBcZGgVArERYBSORCnHKWSIE4xSmVBnFKUSoM4hSiVB3HKUAjS0YUSLciDBnBjBzBT8ze3ZSq0R7wgVoD7GTBbA6aNn5mrtUN7xA1iPaMQRHShEER0oRBEdKEQRHShEER0oRBEdKEQRHShEER0oRBEdKEQRHShEER0oRBEdKEQRHShEER0oRBEdKEkCdLbCzw/AKwcKneKNYq1fKIkBfJwP7BxHfj6GWOrWGtj5sfaPlCSAenuBjafIVjDp0C3MTrKzdrZNEDenEHw1iZHv8vzrJUGyGA6NAcwuEqQrfkwF5oD36+BIATxHkGEIKVEkD+ArF8p/4dhsQZBtgny9tzom/O3KdYgCEFKjyBCEBCEICCIEIQgQhCCeI4gQhAQhCAgiBCEIEIQgniOIFIBkHX+H6ILJEQEIUgpEUQIUkoE+W14clEZSHGuNnRrPNv7a4qT58Mn4TCGj0c//Z4UyNbzIbPjfT7kyydgcA3o7Rv9+pMD+Tm9ifE9QbXc9HfdyYLYiIcgomsIIrqGIKJrCCK6hiCiawgiukYJSJyvXrWlgJwI7RHvy4ltCbO082Boj3hf32193x0yxKrJjIZg5ULwDbHB57zREhZMA1ZeVvjuWMELs8toCsumCSt3Kohxq/jsRmtYqh9FLpeQSwc2W0xycukglza69SOh95sxxhhjjJlt9A1uJouDbg5ITgAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  );
}
